<script setup>
import BaseFeature from "../components/BaseFeature.vue";
import { inject } from "vue";

const features = [
  {
    title: "Платежи и оплата услуг",
    text: "Мобильный телефон, интернет, услуги ЖКХ и штрафы ГИБДД",
    image: "/assets/icons/payment-icon.png"
  },
  {
    title: "Транспортная карта",
    text: "Пополнить транспортный кошелек, сменить тариф",
    image: "/assets/icons/transport-icon.png"
  },
  {
    title: "Управление продуктами",
    text: "Оформить карту, кредит, открыть вклад онлайн",
    image: "/assets/icons/products-icon.png"
  },
  {
    title: "Переводы по номеру телефона",
    text: "Внутри банка и по СБП. Есть распознавание номера по фото",
    image: "/assets/icons/sbp-icon.png"
  },
  {
    title: "ID жителя Якутии",
    text: "Вместо льготного удостоверения",
    image: "/assets/icons/resident-icon.png"
  },
  {
    title: "Онлайн-сервисы",
    text: "Заказ справок и выписок по счетам, курсы валют",
    image: "/assets/icons/services-icon.png"
  },
]

const view = inject("view", "mobile")
</script>

<template>
  <section class="screen screen-container opportunity">
    <h2 
      v-motion 
      :initial="{opacity: 0, y: 200}"
      :visibleOnce="{opacity: 1, y: 0, transition: {duration: 1500}}"
    >Возможности</h2>

    <div class="opportunity__content">
      <BaseFeature 
        v-for="(feature, index) in features" 
        :key="index"
        v-motion
        :title="feature.title"
        :text="feature.text"

        :image="feature.image" 
        :initial="{opacity: 0, y: 100}"
        :visible-once="{
          opacity: 1, y: 0, 
          transition: view == 'desktop'
          ? {
            duration: 1500,
            delay: 400 + 200 * index
          }
          : {
            duration: 1500,
            delay: 400
          }
        }"
      />
    </div>
  </section>
</template>


<style lang="scss">
.opportunity {
  gap: 120px;
  height: 100vh;
  justify-content: center;

  @media screen and (max-height: 800px) {
    gap: 80px;
  }

  @media screen and (max-width: 800px) {
    gap: 80px;
    height: auto;
  }

  h2 {
    font-size: var(--font-size-lg);
  }

  &__content {
    gap: 30px;
    display: flex;
    flex-wrap: wrap;
  }
}

</style>
